var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { P, PCSS, CustomElement, Defaults, ViewChild } from '@pacem/pacem-core';
import { PacemTextualInputElement } from './input';
//namespace Pacem.Components.Scaffolding {
let PacemTelInputElement = class PacemTelInputElement extends PacemTextualInputElement {
    constructor() {
        super();
    }
    toggleReadonlyView(readonly) {
        this.input.hidden = readonly;
        this.anchor.hidden = !readonly;
    }
    get inputFields() {
        return [this.input];
    }
};
__decorate([
    ViewChild('input[type=tel]')
], PacemTelInputElement.prototype, "input", void 0);
__decorate([
    ViewChild(P + '-a')
], PacemTelInputElement.prototype, "anchor", void 0);
PacemTelInputElement = __decorate([
    CustomElement({ tagName: P + '-input-tel', template: `<input type="tel" class="${PCSS}-input" /><${P}-a class="${PCSS}-readonly" disabled="{{ $pacem.isNullOrEmpty(:host.value) }}" href="{{ 'tel:'+ :host.value }}"><${P}-text text="{{ :host.viewValue }}"></${P}-text></${P}-a>`, shadow: Defaults.USE_SHADOW_ROOT })
], PacemTelInputElement);
export { PacemTelInputElement };
